import React from 'react';
import { HomeLayout } from 'modules/home/components/HomeLayout';
import { onboardingElementIds } from 'services/onboarding/constants';
import { Box, Link, Typography } from '@mui/material';
import { UsageField } from 'components/UsageField';

export const HomeUsagePageTab: React.FC = () => {
  return (
    <HomeLayout>
      <div id={onboardingElementIds.homePageContainer}>
        <Box sx={{ mt: 8 }}>
          <UsageField
            subtitle={
              <Typography>
                Contact{' '}
                <Link href="mailto:support@joinpopp.com?subject=Request more credits">
                  support@joinpopp.com
                </Link>{' '}
                <span>to order more conversation or analysis credits.</span>
              </Typography>
            }
          />
        </Box>
      </div>
    </HomeLayout>
  );
};
